<script setup>
setPageTitle(PageMeta.Invoices.Edit.Title)
definePage({ meta: PageMeta.Invoices.Edit.Meta })

import InvoicesEditPage from '@/views/Previews/Invoices/InvoicesEditPage.vue'

/* ** */
</script>

<template>
  <InvoicesEditPage />
</template>
